export const parseAndValidateUrl = (
  url: string,
  baseOrigin: string
): URL | null => {
  try {
    const urlObj = new URL(url, baseOrigin);

    if (urlObj.origin !== baseOrigin) {
      return null;
    }

    return urlObj;
  } catch (error) {
    console.error('Error parsing URL:', error);
    return null;
  }
};

export const isValidOrigin = (url: string): boolean => {
  const urlObj = parseAndValidateUrl(url, window.location.origin);
  return urlObj !== null;
};

export const getFullUrlPath = (urlObj: URL): string =>
  urlObj.pathname + urlObj.search;
